import { BusinessUnits } from "@app/provider/drawRequest";
import { DrawCoordinator } from "@app/provider/types";
import { ManagedBy } from "@app/provider/testData/types";
import { businessUnitMapper } from "@app/utils/businessUnitMapper";

/**
 * Maps an order's coordination signal to the Heap-facing `draw_coordinator`
 * value. Women's Health has no draw-coordinator concept (blank), and an
 * undetermined `managedBy` is also left blank.
 */
export const getDrawCoordinatorForHeap = ({
  businessUnit,
  managedBy,
}: {
  businessUnit?: string;
  managedBy?: ManagedBy;
}): DrawCoordinator | undefined => {
  // Resolved at call time (not module load) to avoid a circular-import
  // initialization order issue where `BusinessUnits` is still undefined.
  const womensHealthBusinessUnit = businessUnitMapper(
    BusinessUnits.WOMENS_HEALTH
  );

  // The mapper must always resolve Women's Health. If it returns undefined
  // (e.g. a broken enum ref / circular-import init order), return a safe
  // default rather than comparing against `undefined` — which would mislabel
  // an order that simply has no business unit as Women's Health. No warning is
  // logged here to avoid noisy browser console output; the server helper logs.
  if (womensHealthBusinessUnit === undefined) {
    return undefined;
  }

  if (businessUnit === womensHealthBusinessUnit) {
    return undefined;
  }

  switch (managedBy) {
    case ManagedBy.NATERA:
      return DrawCoordinator.NATERA;
    case ManagedBy.CLINIC:
      return DrawCoordinator.CLINIC;
    default:
      return undefined;
  }
};
